import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { MagnifyingGlassSVG } from '@common_components/svg/magnifyingGlass.svg';

const MagnifyingGlassIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <MagnifyingGlassSVG/>
    </div>
  );
};

export { MagnifyingGlassIcon };
